import React from "react";
import { FaHome } from "react-icons/fa";

const HomeLogo = () => <FaHome color="black" size={"40px"} />;

export default HomeLogo;
